import type { FC } from "react";
import { useCallback, useState } from "react";

import { sendTelemetryEvent } from "@/lib/telemetry";
import SpecialCashbackBrands from "@/src/cashback/LandingPage/SpecialCashbackBrands";
import type { ICashbackBrandsTileDictionary } from "@/src/cashback/MainPage/BrandsCashbackSection";
import { TelemetryEntity } from "@Components/Modules/Helpers";

import CashbackCategories, { type ICashbackCategory } from "../CashbackCategories";
import type { ICashbackBrandsByCategory } from "../CashbackCommonInterfaces";

export interface IPopularCashbackBrands {
    cashbackBrandsByCategories: ICashbackBrandsByCategory[];
    allBrands: ICashbackBrandsTileDictionary;
    categories: ICashbackCategory[];
}

const keyCategoryPopular = "00000000-0000-0000-0000-000000000000";

const PopularCashbackBrands: FC<IPopularCashbackBrands> = (props) => {
    const [brandsByCategory, setBrandsByCategory] = useState<string[]>(
        props.cashbackBrandsByCategories?.find((c) => c.categoryKey === keyCategoryPopular)?.initialData ||
            [],
    );

    const onChangeCategory = useCallback((categoryKey: string, categoryCode: string) => {
        const updateList =
            props.cashbackBrandsByCategories?.find((c) => c.categoryKey === categoryKey)?.initialData || [];
        setBrandsByCategory(updateList);
        sendTelemetryEvent({
            eventName: `${TelemetryEntity.Cashback}-${TelemetryEntity.Category}`,
            actionType: "Click",
            itemId: categoryCode,
        });
    }, []);

    return (
        <>
            <CashbackCategories
                initialCategoryId={keyCategoryPopular}
                onChangeCategory={onChangeCategory}
                initialData={props.categories}
            />
            <SpecialCashbackBrands cashbackBrands={brandsByCategory?.map((b) => props.allBrands[b])} />
        </>
    );
};

export default PopularCashbackBrands;
